// import dispatcher from '../dispatcher';
import firstScrollStore from '../scroll/first-scroll.store';

var header;

var _handleFirstScroll = function() {
	var scrolled = firstScrollStore.getData().scrolled;
	if (scrolled) {
		header.classList.add('shrink');
	} else {
		header.classList.remove('shrink');
	}
}

var init = function() {
	header = document.getElementsByTagName('header')[0];

	_handleFirstScroll();
	firstScrollStore.subscribe(_handleFirstScroll);
}

export default {
	init: init
};